<i18n src="@/lang/actions" />
<i18n src="@/lang/confirmations" />
<i18n>
    {
        "en":{
            "enabled": "Available for installation",
            "disabled": "Not available for installation"
        },
        "ru":{
            "enabled": "Доступные для установки",
            "disabled": "Недоступные для установки"
        },
        "ua":{
            "enabled": "Доступні для встановлення",
            "disabled": "Недоступні для встановлення"
        }
    }
</i18n>

<template>
  <el-main>
    <template v-for="(v, section) in widgets">
      <section-divider :text="$t(section)" :key="`d-${section}`" />
      <div
        :style="{
          display: 'flex',
          'flex-wrap': 'wrap',
          filter: `grayscale(${Number(section === 'disabled')})`
        }"
        :key="`c-${section}`"
      >
        <component
          v-for="(widget, i) in widgets[section]"
          :key="i"
          :is="require('../widgets/elements/widget_card').default"
          :widget="widgets[section][i]"
          :amo="amo"
          :click-handler="
            () => {
              section === 'enabled' ? handleCardClick(widgets[section][i]) : '';
            }
          "
        />
      </div>
    </template>
  </el-main>
</template>

<script>
import SharedWidgets from "../../store/classes/SharedWidgets";
import SectionDivider from "./elements/SectionDivider";

export default {
  name: "ServicesInstall",
  components: { SectionDivider },
  props: {
    id: String, // this is Customer id
    amo_id: String
  },
  data: () => ({
    widgets: {
      enabled: [],
      disabled: []
    }
  }),
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = new Map(
        (
          await this.$api.query({
            query: require("../../graphql/widgets/widgets_list.graphql"),
            variables: {
              filter: {
                enabled: true
              },
              customer: this.customer,
              amo: this.amo
            }
          })
        ).data.shared_widgets_list.map(v => [v.uuid, new SharedWidgets(v)])
      );
      if (!res.size) {
        return;
      }
      this.services.forEach(v => {
        if (res.has(v.sharedWidgets_uuid)) {
          this.widgets.disabled.push(res.get(v.sharedWidgets_uuid));
          res.delete(v.sharedWidgets_uuid);
        }
      });
      this.widgets.enabled = [...res.values()];
    },
    handleCardClick(widget) {
      this.$confirm(
        this.$t("confirmations.install_widget")
          .replace(/{widget}/, widget.name)
          .replace(/{customer}/, this.customer.name)
          .replace(/{amo}/, this.amo.domain),
        {
          confirmButtonText: this.$t("actions.install"),
          cancelButtonText: this.$t("actions.cancel"),
          type: "info",
          center: true,
          dangerouslyUseHTMLString: true
        }
      )
        .then(async () => {
          // await widget.installFor(this.customer, this.amo);
          await widget.installForAsIntegration(this.customer, this.amo);
          let s = (
            await this.$api.query({
              query: require("../../graphql/services/services_list.graphql"),
              variables: {
                customer: (this.customer || {}).uuid,
                amo: (this.amo || {}).uuid
              }
            })
          ).data.shared_customers_services_list.find(
            v => v._embedded.sharedWidgets.code === widget.code
          ).uuid;
          this.$log({
            name: "customers.details.installed_services.details",
            params: Object.assign({ service_id: s }, this.$route.params)
          });
          this.$log(s);
          await this.$router.replace({
            name: "customers.details.installed_services.details",
            params: Object.assign({ service_id: s }, this.$route.params)
          });
        })
        .catch(() => {});
    }
  },
  computed: {
    amo() {
      return this.$attrs.amo;
    },
    customer() {
      return this.$attrs.customer;
    },
    services() {
      return this.$attrs.services;
    }
  }
};
</script>

<style scoped></style>
